import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import AgGridWrapper from "../../AgGridWrapper";
import { filterParams, cellRenderer } from "../../utils/ReportUtils";
import { useTranslation } from "react-i18next";

function ArchivedFolioReport({ data }) {
  const { t } = useTranslation();

  // getting the hotel id from the params
  const url = new URL(window.location.href);
  const hotelId = url.searchParams.get("hotelId");

  const HeaderCheckbox = (props) => {
    const { api, columnApi } = props;

    const handleHeaderCheckboxChange = (event) => {
      // Use forEachNodeAfterFilter to iterate over filtered rows
      api.forEachNodeAfterFilter((node) => {
        node.setSelected(event.target.checked);
      });
    };

    return (
      <label>
        <input
          type="checkbox"
          onChange={handleHeaderCheckboxChange}
          style={{
            marginRight: "18px",
            transform: "scale(1.2)",
          }}
        />
        Booking ID
      </label>
    );
  };

  const columns = [
    {
      field: "bookingId",
      headerName: `${t("Booking ID")}`,
      // cellRendererFramework: (params) => cellRenderer(params, hotelId),
      checkboxSelection: true,
      headerComponentFramework: HeaderCheckbox,
      dataType: "varchar",
      printWidth: "10%",
      width: 250,
    },
    {
      field: "bookingMadeOn",
      headerName: `${t("Booking creation date")}`,
      dataType: "date",
    },
    {
      field: "deletedAt",
      headerName: `${t("Booking deletion date")}`,
      dataType: "date",
    },
    { field: "checkin", headerName: `${t("CheckIn")}`, dataType: "date" },
    { field: "checkout", headerName: `${t("Checkout")}`, dataType: "date" },

    {
      field: "userName",
      headerName: `${t("Guest Name")}`,
      dataType: "varchar",
      printWidth: "12%",
    },
    {
      field: "deletedBy",
      headerName: `${t("Deleted by")}`,
      dataType: "varchar",
      printWidth: "12%",
    },
  ];

  // Setting the pinned row
  const [pinnedRow, setPinnedRow] = useState(null);
  function createPinnedData(params, rowsData) {
    // let result = {
    //   bookingid_display: "Total",
    //   booking_amount: 0,
    //   payment_made: 0,
    //   deposit_made: 0,
    //   refund: 0,
    //   balance_due: 0,
    //   promo_discount: 0,
    //   promo_discount_tax: 0,
    // };
    // function updateVals(i) {
    //   result.booking_amount += i.booking_amount;
    //   result.payment_made += i.payment_made;
    //   result.refund += i.refund;
    //   result.deposit_made += i.deposit_made;
    //   result.balance_due += i.balance_due;
    //   result.promo_discount += i.promo_discount;
    //   result.promo_discount_tax += i.promo_discount_tax;
    // }
    // params.api.getSelectedRows().length === 0
    //   ? params.api.forEachNodeAfterFilter((row) => updateVals(row.data))
    //   : params.api.getSelectedRows().map((row) => updateVals(row));
    // setPinnedRow([result]);
    // params.api.setPinnedBottomRowData([result]);
  }

  return (
    <AgGridWrapper
      reportName={t("Archived Folio Report")}
      columns={columns}
      reportActualType={"get-deleted-bookings-report"}
      createPinnedData={createPinnedData}
      enableCustomizedReport={false}
      pinnedRow={pinnedRow}
      hideIcon={false}
      enableDateTypeFilters={true}
    />
  );
}

function mapStateToProps(state) {
  return { data: state.auth.selectedHotel };
}
export default connect(mapStateToProps)(ArchivedFolioReport);
